import React from "react";
import { InView } from "react-intersection-observer"; // Import InView

const ProgressBar = ({ title, percentage, color, classAppend, font }) => {
  return (
    <InView triggerOnce>
      {({ inView, ref }) => (
        <>
          <div className={"progress-bar-title " + (classAppend || "")}>
            {title}
          </div>
          <div className="progress" ref={ref}>
            <div
              className={
                "progress-bar " +
                (classAppend || "") +
                " " +
                (inView ? "animated " : "")
              }
              style={{
                width: inView ? `${percentage}%` : "20%",
                background: color ? color : "",
              }}
            ></div>
            <span className={font || ""}>{percentage}%</span>
          </div>
        </>
      )}
    </InView>
  );
};

export default ProgressBar;
